import React from 'react'
import { Button, Stack, SvgIcon, Typography } from '@mui/material'
import { ReactComponent as AtlasLogo } from '../../assets/images/atlas-logo.svg'
import { useAuth0 } from '../../contexts/auth0-context'

// Replaces the whole app rather than sitting over it: nothing should be reachable or visible.
export const AccountDisabledScreen = () => {
    const { logout } = useAuth0()

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            gap={3}
            px={3}
            textAlign="center"
            bgcolor="figma.grayscale.frameBackground"
        >
            <SvgIcon component={AtlasLogo} inheritViewBox sx={{ fontSize: 56, color: 'figma.primary' }} />

            <Stack gap={1.5} maxWidth={520}>
                <Typography variant="28x600" color="figma.grayscale.textHier1">
                    Your account has been disabled
                </Typography>
                <Typography variant="18x400" color="figma.grayscale.textHier2">
                    You no longer have access to Atlas. Please contact your organization administrator if you think this
                    is a mistake.
                </Typography>
            </Stack>

            <Button
                onClick={() => logout?.({ returnTo: window.location.origin })}
                variant="contained"
                color="primary"
                sx={{ height: 52, borderRadius: '14px', px: 4 }}
            >
                Log Out
            </Button>
        </Stack>
    )
}

export default AccountDisabledScreen
